// extracted by mini-css-extract-plugin
export default {"box":"carroFicha_box__E2DPA","navbarScrollCustom":"carroFicha_navbarScrollCustom__1FBqc","rectangle":"carroFicha_rectangle__0GLzs"};